/* Options:
Date: 2020-06-13 21:57:44
Version: 5.91
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5001

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/

export interface IReturn<T> {
    createResponse(): T;
}

export interface IReturnVoid {
    createResponse(): void;
}

export interface IHasSessionId {
    sessionId: string;
}

export interface IHasBearerToken {
    bearerToken: string;
}

export interface IPost { }
export interface IPut { }
export interface IDelete { }

// @DataContract
export class ResponseError {
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string };

    public constructor(init?: Partial<ResponseError>) {
        (Object as any).assign(this, init);
    }
}

// @DataContract
export class ResponseStatus {
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string };

    public constructor(init?: Partial<ResponseStatus>) {
        (Object as any).assign(this, init);
    }
}

export class HelloResponse {
    public result: string;

    public constructor(init?: Partial<HelloResponse>) {
        (Object as any).assign(this, init);
    }
}

export class CheckUsernameResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckUsernameResponse>) {
        (Object as any).assign(this, init);
    }
}

export class CheckUserFirstLastNameResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckUserFirstLastNameResponse>) {
        (Object as any).assign(this, init);
    }
}

export class CheckFirstLastNameResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckFirstLastNameResponse>) {
        (Object as any).assign(this, init);
    }
}

export class CheckExistingIIDPUsernameResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckExistingIIDPUsernameResponse>) {
        (Object as any).assign(this, init);
    }
}

export class VerificationResponse {
    public Result: string;
    public constructor(init?: Partial<VerificationResponse>) {
        (Object as any).assign(this, init);
    }
}
// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken {
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    // public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string };

    public uniqueId: string;

    public constructor(init?: Partial<AuthenticateResponse>) {
        (Object as any).assign(this, init);
    }
}

// @DataContract
export class AssignRolesResponse {
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) {
        (Object as any).assign(this, init);
    }
}

// @DataContract
export class UnAssignRolesResponse {
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) {
        (Object as any).assign(this, init);
    }
}

// @DataContract
export class RegisterResponse {
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public referrerUrl: string;

    // @DataMember(Order=5)
    public bearerToken: string;

    // @DataMember(Order=6)
    public refreshToken: string;

    // @DataMember(Order=7)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=8)
    public meta: { [index: string]: string };

    public uniqueId: string;

    public constructor(init?: Partial<RegisterResponse>) {
        (Object as any).assign(this, init);
    }
}

// @Route("/hello")
// @Route("/hello/{Name}")
export class Hello implements IReturn<HelloResponse> {
    public name: string;

    public constructor(init?: Partial<Hello>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new HelloResponse();
    }
    public getTypeName() {
        return 'Hello';
    }
}

// @Route("/verification/{Id}")
export class Verification implements IReturn<VerificationResponse> {
    public Id: string;
    public constructor(init?: Partial<Verification>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new VerificationResponse();
    }
    public getTypeName() {
        return 'VerificationRequest';
    }
}

// @Route('/checkusername')
// @Route('/checkusername/{UserName}')
export class CheckUsername implements IReturn<CheckUsernameResponse> {
    public userName: string;

    public constructor(init?: Partial<CheckUsername>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new CheckUsernameResponse();
    }
    public getTypeName() {
        return 'CheckUsername';
    }
}

// @Route('/checkuserfirstlastname')
// @Route('/checkuserfirstlastname/{firstName}/{lastName}')
export class CheckUserFirstLastName implements IReturn<CheckUserFirstLastNameResponse> {
    public firstName: string;
    public lastName: string;

    public constructor(init?: Partial<CheckUserFirstLastName>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new CheckUserFirstLastNameResponse();
    }
    public getTypeName() {
        return 'CheckUserFirstLastName';
    }
}


// @Route('/checkfirstlastname')
// @Route('/checkfirstlastname/{firstName}/{lastName}')
export class CheckFirstLastName implements IReturn<CheckFirstLastNameResponse> {
    public firstName: string;
    public lastName: string;

    public constructor(init?: Partial<CheckFirstLastName>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new CheckFirstLastNameResponse();
    }
    public getTypeName() {
        return 'CheckFirstLastName';
    }
}

export class CheckExistingIIDPUsername implements IReturn<CheckExistingIIDPUsernameResponse> {
    public userName: string;

    public constructor(init?: Partial<CheckExistingIIDPUsername>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new CheckExistingIIDPUsernameResponse();
    }
    public getTypeName() {
        return 'CheckExistingIIDPUsername';
    }
}

export class CheckEmail implements IReturn<CheckEmailResponse> {
    public email: string;
    public constructor(init?: Partial<CheckEmail>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new CheckEmailResponse();
    }
    public getTypeName() {
        return 'CheckEmail';
    }
}

export class CheckEmailResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckEmailResponse>) {
        (Object as any).assign(this, init);
    }
}

export class CheckExistingIIDPEmail implements IReturn<CheckExistingIIDPEmailResponse> {
    public email: string;
    public constructor(init?: Partial<CheckExistingIIDPEmail>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new CheckExistingIIDPEmailResponse();
    }
    public getTypeName() {
        return 'CheckExistingIIDPEmail';
    }
}

export class CheckExistingIIDPEmailResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckExistingIIDPEmailResponse>) {
        (Object as any).assign(this, init);
    }
}

export class CheckPrimaryContact implements IReturn<CheckPrimaryContactResponse> {
    public appId: string;
    public constructor(init?: Partial<CheckPrimaryContact>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new CheckPrimaryContactResponse();
    }
    public getTypeName() {
        return 'CheckPrimaryContact';
    }
}

export class CheckPrimaryContactResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckPrimaryContactResponse>) {
        (Object as any).assign(this, init);
    }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost {
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=16)
    public useTokenCookie?: boolean;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string };

    public constructor(init?: Partial<Authenticate>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new AuthenticateResponse();
    }
    public getTypeName() {
        return 'Authenticate';
    }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost {
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string };

    public constructor(init?: Partial<AssignRoles>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new AssignRolesResponse();
    }
    public getTypeName() {
        return 'AssignRoles';
    }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost {
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string };

    public constructor(init?: Partial<UnAssignRoles>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new UnAssignRolesResponse();
    }
    public getTypeName() {
        return 'UnAssignRoles';
    }
}

// @Route("/register")
// @DataContract
export class Register implements IReturn<RegisterResponse>, IPost {
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public FirstName: string;

    // @DataMember(Order=3)
    public lastName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public email: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public confirmPassword: string;

    // @DataMember(Order=8)
    public autoLogin?: boolean;

    // @DataMember(Order=10)
    public errorView: string;

    // @DataMember(Order=11)
    public meta: { [index: string]: string };

    public constructor(init?: Partial<Register>) {
        (Object as any).assign(this, init);
    }
    public createResponse() {
        return new RegisterResponse();
    }
    public getTypeName() {
        return 'Register';
    }

}
// @Route("/resend-verification", "POST")
export class ResendVerificationRequest implements IReturn<ResendVerificationResponse> {
    public Email: string; // must match C# exactly

    public constructor(init?: Partial<ResendVerificationRequest>) {
        Object.assign(this, init);
    }

    public createResponse() {
        return new ResendVerificationResponse();
    }

    public getTypeName() {
        return 'ResendVerificationRequest';
    }
}

export class ResendVerificationResponse {
    public message: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ResendVerificationResponse>) {
        Object.assign(this, init);
    }

}

// @Route("/checkverificationemail/{Email}", "GET")
export class CheckVerificationEmail implements IReturn<CheckVerificationEmailResponse> {
    public email: string;

    public constructor(init?: Partial<CheckVerificationEmail>) {
        Object.assign(this, init);
    }

    public createResponse() {
        return new CheckVerificationEmailResponse();
    }

    public getTypeName() {
        return 'CheckVerificationEmail';
    }
}
export class CheckVerificationEmailResponse {
    public result: boolean;

    public constructor(init?: Partial<CheckVerificationEmailResponse>) {
        Object.assign(this, init);
    }
}
